import { render, staticRenderFns } from "./manage-request-sellers.modal.vue?vue&type=template&id=d445a720&scoped=true"
import script from "./manage-request-sellers.modal.vue?vue&type=script&lang=js"
export * from "./manage-request-sellers.modal.vue?vue&type=script&lang=js"
import style0 from "./manage-request-sellers.modal.vue?vue&type=style&index=0&id=d445a720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d445a720",
  null
  
)

export default component.exports